import React from "react";
import MainTable from '../../Components/Tables/Main/MainTable'
import { useProviders } from "../../Hooks/useProviders";

const Providers = () => {
    const [providersData, addProvider, updateProvider, deleteProvider] = useProviders();

    const columns = [
        { title: "Id", field: "id", hidden: true },
        { title: "Nombre", field: "name", defaultSort: 'asc' },
        { title: "Dirección", field: "address" },
        { title: "Email", field: "email" },
        { title: "Teléfono", field: "telephone" },
        { title: "Contacto", field: "contact" }
    ];

    return <MainTable
        title="Proveedores"
        columns={columns}
        data={providersData}
        requiredFields={["name", "address"]}
        deleteText="No se borrará data asociada"
        onRowAdd={addProvider}
        onRowUpdate={async (newData) => {
            const dataToSave = { ...newData }
            delete dataToSave.id
            await updateProvider(dataToSave, newData.id);
        }}
        onRowDelete={deleteProvider}
    />
}

export default Providers


// WEBPACK FOOTER //
// ./src/Containers/Providers/Providers.js